import styled from 'styled-components';
import Gauge from '../Gauge';
import { statCard } from 'shared/styles/theme';


const StatGaugeCard = ({ title, value, unit, icon, ratio = 0 }) => (
  <Card>
    <Gauge ratio={ratio} icon={icon} alt={title} size={56} stroke={5} />
    <Value>
      {value}
      {unit && <Unit>{unit}</Unit>}
    </Value>
    <Label>{title}</Label>
  </Card>
);

export default StatGaugeCard;

const Card = styled.div`
  width: 115px;
  height: 75px;
  border-radius: 14px;

  background: ${statCard.bg};
  border: 0.8px solid ${statCard.border};
  box-shadow: 0px 1px 1.5px rgba(0, 0, 0, 0.5);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 4px 4px 5px;
  gap: 1px;
`;
const Value = styled.span`
  display: flex;
  align-items: baseline;
  gap: 2px;
  font-size: 10px;
  font-weight: 600;
  color: ${statCard.value};
`;
const Unit = styled.span`
  font-size: 8px;
  font-weight: 600;
`;
const Label = styled.span`
  font-size: 7px;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;
  color: ${statCard.label};
`;
